/** Default display name for SMS consent PoC; override via `?businessName=` on the consent URL. */
export const DEFAULT_BUSINESS_NAME = 'Garden Gables';

/** Mews Navigator guest-facing terms document (property-specific when multi-tenant wiring exists). */
export const TERMS_OF_SERVICE_URL =
  'https://app.mews.com/Navigator/documents/022bc744-5770-44fb-b5ac-b3df012ae320?language=en-US';

export const PRIVACY_POLICY_URL = 'https://www.gardengables.com/privacy-policy/';
